import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFormDiamond: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconFormDiamond"><Path d="M10.0553 2.63404C11.1292 1.5603 12.8701 1.5603 13.944 2.63404L21.3659 10.0559C22.4392 11.1298 22.4395 12.8708 21.3659 13.9446L13.944 21.3665C12.8702 22.4401 11.1292 22.4398 10.0553 21.3665L2.63343 13.9446C1.55969 12.8707 1.55969 11.1298 2.63343 10.0559L10.0553 2.63404Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFormDiamond;
